import script from "./AudioInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioInput.vue?vue&type=script&setup=true&lang=ts"

import "./AudioInput.vue?vue&type=style&index=0&id=feac9688&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feac9688"]])

export default __exports__